module.exports = __webpack_public_path__ + "img/2.329614f6.png";